import React from 'react';
import { CTAButton } from './CTAButton';
import { FINAL_CTA_IMAGE } from '../data/hero';
export function FinalCTA() {
  return <section aria-label="Accédez au système" className="bg-obsidian text-white" data-id="element-72" data-mp="3udyi1slbkpl5">
      <div className="mx-auto grid max-w-6xl items-center gap-10 px-5 py-16 text-center lg:grid-cols-2 lg:py-24 lg:text-left" style={{
      paddingTop: "23px",
      paddingBottom: "33px"
    }} data-id="element-73" data-mp="c7tv9kju0su1">
        <div data-id="element-74" data-mp="m4ezw4rxw1xc">
          <h2 className="font-display text-4xl font-extrabold uppercase leading-[0.95] sm:text-6xl" data-id="element-75" data-mp="m3wxsrilithi">
            Entraînez-vous plus intelligemment.
            <br data-id="element-76" data-mp="h413jjzpagf5" />
            Gérez mieux votre ravitaillement.
            <br data-id="element-77" data-mp="vtgkk89fj7hn" />
            <span className="text-electric" data-id="element-78" data-mp="vtypdta5qu16">Abordez votre course avec confiance.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-md text-lg text-white/70 lg:mx-0" data-id="element-79" data-mp="qxrqgkg6iisq">
            Un système pour organiser votre parcours, de l'entraînement jusqu'à la ligne d'arrivée.
          </p>
          <div className="mt-8 flex justify-center lg:justify-start" data-id="element-80" data-mp="zy6e3qgm89ze">
            <CTAButton href="#pricing" data-id="element-81" data-mp="2c5pwfty27a1n">Accédez au système complet</CTAButton>
          </div>
          <p className="mt-3 text-xs text-white/50" data-id="element-82" data-mp="2h2y8dcsm6hug">27 € · Paiement unique · Garantie de 7 jours</p>
        </div>
        <img src={FINAL_CTA_IMAGE} alt="Collection LE SYSTÈME TRIATHLON LONGUE DISTANCE™ avec ses quatre outils pratiques" width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto h-auto w-full max-w-[560px]" data-id="element-83" data-mp="2m21cmv0rsk1d" />
      </div>
    </section>;
}